import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import Link from "react-router-dom/Link";

import logoQuiz from "../../images/logo-quiz-vacances.png";
import Logo from "../Logo";
import { Layout, Header, ImageLogo, Main, Footer, LegalButton, LoadingText } from "./style";
import LegalInformations from "../../components/LegalInformations";
import routes from "package-common-react/lib/routes";

export default compose(connect(({ app }) => app))(function MainLayout({
  loading,
  children
}) {
  return (
    <Layout>
      <Header>
        <Link to={routes.home.path}>
          <ImageLogo src={logoQuiz} alt="Quiz Cahier de Vacances" />
        </Link>
        <Logo mini />
      </Header>
      <Main>
        {loading ? (
          <LoadingText>Chargement des questions&hellip;</LoadingText>
        ) : (
          children
        )}
      </Main>
      <Footer>
        <LegalButton>{({state, hide}) => <LegalInformations state={state} hide={hide} />}</LegalButton>
      </Footer>
    </Layout>
  );
});



// WEBPACK FOOTER //
// ./src/components/MainLayout/index.js